<template>
  <header class="layout-head">
    <div class="layout_header_top def-w f-jb-ac fc99">
      <div class="top-left f-ac">
        <span>{{ site.name }}欢迎您！</span>
        <span class="fc" v-show="isLogin"
          >{{ userInfo.displayName }}，您好！</span
        >
        <div class="btn f-ac">
          <template v-if="!isLogin">
            <span @click="handleClick('login')">登录</span>
            <div class="divider-line"></div>
            <span @click="handleClick('register')">注册</span>
          </template>
          <span @click="handleClick('member')">会员中心</span>
          <span @click="loginOut" v-if="isLogin">退出登录</span>
        </div>
      </div>
      <div class="top-right f-ac">
        咨询电话：<span>{{ site.consultHotline }}</span>
        <div class="btn f-ac">
          <span @click="handleClick('hysz')">化云数智</span>
          <div class="divider-line"></div>
          <span @click="handleClick('download')">下载专区</span>
        </div>
      </div>
    </div>
    <div class="layout_head_container">
      <div class="def-w f-jb-ac">
        <a href="/web/" :title="site.name">
          <img :src="site.topLogo" :alt="site.name" />
        </a>
        <head-search />
      </div>
    </div>
    <head-nav v-if="!$route.meta.hideNav" />
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { loginOut, generateSsoToken } from "@/api/home";
import { buildAuthUrl } from "@/utils/common";

import HeadSearch from "./HeadSearch.vue";
import HeadNav from "./HeadNav.vue";

export default {
  name: "LayoutHead",
  components: { HeadNav, HeadSearch },
  props: {},
  data() {
    return {
      urlMap: {
        login: process.env.VUE_APP_LOGIN_URL,
        register: process.env.VUE_APP_REGISTER_URL,
        member: process.env.VUE_APP_MEMBER_URL,
        hysz: process.env.VUE_APP_HYSZ_URL,
      },
    };
  },
  computed: {
    ...mapGetters(["site", "userInfo", "isLogin"]),
  },
  created() {},
  mounted() {
    // generateSsoToken();
  },
  methods: {
    handleClick(val) {
      if (val === "download") {
        this.$router.push("/info/list/xzzq");
      } else if (val == "hysz") {
        window.open(this.urlMap[val] + "?hyxyToken=" + this.userInfo.token);
      } else if (val == "member" && !this.isLogin) {
        window.open(buildAuthUrl(process.env.VUE_APP_LOGIN_URL, val));
      } else {
        window.open(buildAuthUrl(this.urlMap[val]));
      }
    },
    loginOut() {
      loginOut().then(() => {
        this.$store.commit("permission/SET_USER_INFO", {});
        if (this.$route.params.code === "nb" || this.$route.name === "nbtp") {
          this.$router.push("/");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.layout-head {
  width: 100%;
  background-color: #f5f5f5;
  .layout_header_top {
    height: 40px;
    .top-left,
    .top-right {
      .btn {
        margin-left: 5px;
        span {
          color: $--color-primary;
          cursor: pointer;

          &:last-of-type {
            margin-left: 10px;
          }

          &:hover {
            text-decoration: underline;
            text-underline-offset: 5px;
          }
        }

        .divider-line {
          height: 15px;
          width: 1px;
          border-right: 1px solid $--color-primary;
          margin: 0 5px;
        }
      }
    }

    .top-right {
      .btn {
        margin-left: 15px;
        span:last-of-type {
          margin-left: 0;
        }
      }
    }
  }
  .layout_head_container {
    background-color: #fff;
    .def-w {
      height: 100px;
    }
  }
}
</style>
